import { useParams } from "react-router-dom";
import PrdTable from "@/screens/Prds/prd-table";
import { useApp } from "@/hooks/apps";

// Docs tab: the app's doc-type issues only. Docs are reference material and
// stay out of the Prds tab's state buckets — /prds excludes them by default,
// so this list asks for them explicitly (type=doc).
const AppDocs = () => {
  const { id } = useParams();
  const app = useApp(id);

  if (!app) {
    return (
      <div className="p-4 text-sm text-muted-foreground">App not found.</div>
    );
  }

  const appKey = String(app.code ?? app.id);
  return (
    <PrdTable
      params={{ appId: appKey, type: "doc" }}
      breadcrumb={[{ label: app.name, to: `/apps/${id}/docs` }]}
    />
  );
};

export default AppDocs;
